import Vue from 'vue';
// import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_OUT_STORE_LIST_REQUEST,
    GET_OUT_STORE_LIST_SUCCESS,
    GET_OUT_STORE_LIST_FAILURE,
    UPDATE_OUT_STORE_LIST_PARAMS,
    RESET_OUT_STORE_LIST,
    RESOLVE_OUT_STORE_LIST_PARAMS,
} from '../mutationTypes';

const state = {
    loading: false,
    page: 1,
    pagesize: 20,
    goodsName: '',
    barCode: '',
    outStoreStatus: 0, // 出库方式
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    listData: [],
    pageCount: 1,
    reqParams: {},
};

const mutations = {
    [GET_OUT_STORE_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_OUT_STORE_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
    },
    [GET_OUT_STORE_LIST_FAILURE](state) {
        state.loading = false;
        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_OUT_STORE_LIST_PARAMS](state, params) {
        const { page } = params;
        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
        state[Object.keys(params)[0]] = params[Object.keys(params)[0]];
    },
    [RESET_OUT_STORE_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            page: 1,
            pagesize: 20,
            goodsName: '',
            barCode:'',
            outStoreStatus: 0,
            startEndDate: [],
            listData: [],
            pageCount: 1,
            reqParams: {}
        }));
    },
    [RESOLVE_OUT_STORE_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getOutStoreList({ commit }) {
        commit(GET_OUT_STORE_LIST_REQUEST);
        const res = await Vue.$ajax.get('outboundRecord', state.reqParams);
        if (!res.errorType) {
            commit(GET_OUT_STORE_LIST_SUCCESS, res);
        } else {
            commit(GET_OUT_STORE_LIST_FAILURE);
        }
    },
    resolveOutStoreListParams({ commit }) {
        let params = _.pick(state, ['goodsName', 'barCode', 'outStoreStatus',
            'page', 'pagesize']);

        params = Object.assign({}, params, {
            startDate: state.startEndDate.length ? state.startEndDate[0] : null,
            endDate: state.startEndDate.length ? state.startEndDate[1] : null
        });
        commit(RESOLVE_OUT_STORE_LIST_PARAMS, params);
    },
    resetOutStoreList({ commit }) {
        commit(RESET_OUT_STORE_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/outStore.js